export const ModuleContext = 'context';
export const ModuleOption = "option";
export const ModuleEmployee = "employee";
export const ModuleLayout = "layout";
export const ModuleOrganizationUnit = "organization_unit";
export const ModuleAsset = "asset";
export const ModuleDeviceWideProfile = "deviceWideProfile";
export const ModuleDeviceDeepProfile = "deviceDeepProfile";
export const ModuleWebsiteDeepProfile = "websiteDeepProfile";
export const ModuleWebsiteDeepTaskResult = "websiteDeepTaskResult";
export const ModuleWebsiteWideProfile = "websiteWideProfile";
export const ModuleWebsiteWideTaskResult = "websiteWideTaskResult";
export const ModuleDeviceWideTaskResult = "deviceWideTaskResult";
export const ModuleDeviceDeepTaskResult = "deviceDeepTaskResult";
export const ModuleDevice = "device";
export const ModuleDeviceIssues = "devicesIssues";
export const ModuleWebsiteIssues = "websiteIssues";
export const ModuleWebsite = "website";
export const ModuleScanEngine = "scanEngine";
export const ModuleUsers = "users";
export const ModuleRoles = "roles";
export const ModuleProxy = "proxy";
export const ModuleUserLog = "userLog";
export const ModuleDataLake = "dataLake";
export const ModuleDevicePort = "devicePort";
export const ModuleDeviceWideTaskResultDevice = "deviceWideTaskResultDevice";
export const ModuleDeviceWideTaskResultIssues = "deviceWideTaskResultIssues";
export const ModuleWebsiteWideTaskResultDevice = "websiteWideTaskResultDevice";
export const ModuleWebsiteWideTaskResultIssues = "websiteWideTaskResultIssues";
export const ModuleNetworkLocation = "networkLocation";
export const ModuleExploit = "exploit";
export const ModuleAttackProfile = "attackProfile";
export const ModulePoc = "poc";
export const ModuleLeakAccount = "leakAccount";
export const ModuleLeakSource = "leakSource";
export const ModuleProxyLog = "proxyLog";
export const ModuleNzTemplate = "nzTemplate";
export const ModuleMetasploit = "metasploit";
export const ModuleCvePoc = "cvePoc";
export const ModuleCvePocTask = "cvePocTask";
export const ModuleExploitdbPoc = "exploitdbPoc";
export const ModuleWebsiteIp = "websiteIp";
export const ModuleScheduleJob = "scheduleJob";
export const ModuleScheduleLog = "scheduleLog";
export const ModuleCveDetect = "cveDetect";
export const ModuleWatchlist = "watchlist";
export const ModuleSetting = "setting";
export const ModuleProxyHistory = "proxyHistory";
export const ModuleExploitDB = "exploitDB";
export const ModuleMISP = "misp";
export const ModuleReddit = "reddit";
export const ModuleMonitor = "monitor";
export const ModuleRss = "rss";
export const ModuleChannel = "channel";
export const ModuleEvidences = "evidences";

/**
 * Danh sách module của chương trình
 */
export const AppModules = [
	ModuleContext,
	ModuleOption,
	ModuleEmployee,
	ModuleLayout,
	ModuleOrganizationUnit,
	ModuleAsset,
	ModuleDeviceWideProfile,
	ModuleDeviceDeepProfile,
	ModuleDevice,
	ModuleDeviceIssues,
	ModuleScanEngine,
	ModuleWebsiteDeepProfile,
	ModuleWebsiteDeepTaskResult,
	ModuleWebsiteIssues,
	ModuleWebsite,
	ModuleUsers,
	ModuleWebsiteWideProfile,
	ModuleWebsiteWideTaskResult,
	ModuleDeviceWideTaskResult,
	ModuleDeviceDeepTaskResult,
	ModuleProxy,
	ModuleUserLog,
	ModuleDataLake,
	ModuleDevicePort,
	ModuleDeviceWideTaskResultDevice,
	ModuleDeviceWideTaskResultIssues,
	ModuleWebsiteWideTaskResultDevice,
	ModuleWebsiteWideTaskResultIssues,
	ModuleNetworkLocation,
	ModuleExploit,
	ModuleAttackProfile,
	ModulePoc,
	ModuleLeakAccount,
	ModuleLeakSource,
	ModuleProxyLog,
	ModuleNzTemplate,
	ModuleMetasploit,
	ModuleCvePoc,
	ModuleCvePocTask,
	ModuleExploitdbPoc,
	ModuleWebsiteIp,
	ModuleScheduleJob,
	ModuleScheduleLog,
	ModuleCveDetect,
	ModuleRoles,
	ModuleWatchlist,
	ModuleSetting,
	ModuleProxyHistory,
	ModuleMISP,
	ModuleReddit,
	ModuleMonitor,
	ModuleRss,
	ModuleChannel,
	ModuleEvidences
];
